import { node } from 'prop-types';

import ButtonIcon, { propTypes } from '~/components/ButtonIcons/ButtonIcon';

import { ReactComponent as Close } from '~/assets/images/buttons/closev2.svg';

const CloseButton = ({ CloseIcon, ...props }) => (
  <ButtonIcon {...props}>{CloseIcon ? <CloseIcon /> : <Close />}</ButtonIcon>
);

CloseButton.propTypes = {
  ...propTypes,
  CloseIcon: node,
};

export default CloseButton;
